import { MenuItem, TextField } from '@mui/material';

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  type?: 'text' | 'date' | 'email' | 'number';
  /** with options it becomes a dropdown */
  options?: readonly string[];
  placeholder?: string;
};

/** One form box: text, date, number, or a dropdown when given options */
export function FormField({ label, value, onChange, required, type = 'text', options, placeholder }: Props) {
  return (
    <TextField
      label={label}
      required={required}
      type={type}
      select={Boolean(options)}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      slotProps={type === 'date' ? { inputLabel: { shrink: true } } : undefined}
    >
      {options && [
        <MenuItem key="" value="">
          <em>None</em>
        </MenuItem>,
        // keep a value we do not list (typed earlier, or from a shipment) selectable
        ...[...new Set([...(value && !options.includes(value) ? [value] : []), ...options])].map((o) => (
          <MenuItem key={o} value={o}>
            {o}
          </MenuItem>
        )),
      ]}
    </TextField>
  );
}
